import { z } from "zod";

// =============================================================================
// USER PROFILE SCHEMA (replaces interfaces/profile.d.ts)
// =============================================================================

/**
 * User metadata structure from Supabase Auth
 */
export const userMetadataSchema = z.object({
	firstName: z.string().optional(),
	lastName: z.string().optional(),
	avatar_url: z.string().url().optional(),
	full_name: z.string().optional(),
});

export type UserMetadata = z.infer<typeof userMetadataSchema>;

/**
 * User profile schema matching Supabase User type
 */
export const userProfileSchema = z.object({
	id: z.string().uuid(),
	email: z.string().email().optional(),
	user_metadata: userMetadataSchema.optional(),
	app_metadata: z.record(z.unknown()).optional(),
	created_at: z.string().optional(),
	updated_at: z.string().optional(),
	last_sign_in_at: z.string().optional(),
	role: z.string().optional(),
});

export type UserProfile = z.infer<typeof userProfileSchema>;

/**
 * Session schema
 */
export const sessionSchema = z.object({
	access_token: z.string(),
	refresh_token: z.string(),
	expires_in: z.number(),
	expires_at: z.number().optional(),
	token_type: z.string(),
	user: userProfileSchema,
});

export type Session = z.infer<typeof sessionSchema>;

/**
 * Auth response schema
 */
export const authResponseSchema = z.object({
	user: userProfileSchema.nullable(),
	session: sessionSchema.nullable(),
});

export type AuthResponse = z.infer<typeof authResponseSchema>;

/**
 * Auth error schema
 */
export const authErrorSchema = z.object({
	message: z.string(),
	status: z.number().optional(),
	code: z.string().optional(),
});

export type AuthError = z.infer<typeof authErrorSchema>;
